export default __webpack_public_path__ + "static/media/dog.7cf0f9ad.png";